import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

export default function RecommendedSection() {
  const recommended = comics.filter((c) => c.isRecommended).slice(0, 6);

  return (
    <section className="py-10 md:py-14 bg-background-900/50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground-100">
              编辑推荐
            </h3>
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-thumb-up-line text-primary-500"></i>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
          {recommended.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>

  );
}